/**
 * @file Lazy video
 *
 * Lazy loader for inline videos.
*/

export default class LazyVideo {
    /**
     * Class constructor
     *
     * @arg {object} - `els` Video elements
    */
    constructor (els) {
        if (!els) return;
        this.els = els;

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.src = entry.target.dataset.videoUrl;
                        observer.unobserve(entry.target);
                    }
                });
            });

            this.els.forEach(el => {
                observer.observe(el);
            });
        }
    }
}
